import AcademicMainTypes from '@/helpers/academicMainType';
import ContentType from '@/helpers/contentType';

const hasPermission = (
  academicMainId,
  academicMainTypeId,
  isMarketplace,
  topicTypeId,
  alias,
  userPermissions
) => {
  let permissionAlias = (academicMainTypeId ? AcademicMainTypes.getName(academicMainTypeId) : '');
  if (alias.startsWith('resources')) {
    permissionAlias += '_' + alias.toLowerCase();
  } else if (isMarketplace) {
    permissionAlias += '_marketplace_' + alias.toLowerCase();
  } else if (topicTypeId) {
    permissionAlias += '_' + ContentType.getPermissionAliasById(topicTypeId, alias);
  } else {
    permissionAlias += '_' + alias.toLowerCase();
  }

  if (permissionAlias.startsWith('_')) {
    permissionAlias = permissionAlias.substring(1);
  }

  return !!userPermissions?.find(permission => permission.alias === permissionAlias && permission.academicMainId === academicMainId);
};

const hasPermissions = (
  academicMainId,
  academicMainTypeId,
  isMarketplace,
  topicTypeId,
  aliases,
  userPermissions
) => {
  if (Array.isArray(aliases) && aliases.length) {
    return aliases.some(alias => hasPermission(academicMainId, academicMainTypeId, isMarketplace, topicTypeId, alias, userPermissions));
  } else if (typeof aliases === 'string' && aliases) {
    return hasPermission(academicMainId, academicMainTypeId, isMarketplace, topicTypeId, aliases, userPermissions);
  }

  return false;
};

export { hasPermission, hasPermissions };
